<template>
    <div class="courseware-list">
        <div v-show="!multiSelectionMode" class="search-bar">
            <el-input v-model="query.condition.name" size="medium" clearable placeholder="课件名称"></el-input>
            <div class="btn-group">
                <el-button @click="() => getCoursewareList(query)" type="primary" icon="el-icon-search" plain> 搜索 </el-button>
                <el-button @click="reset" icon="el-icon-refresh">重置</el-button>
            </div>
        </div>
        <div class="toolbar">
            <el-button v-if="multiSelectionMode" @click="() => deleteCourseware(selectionCodes)" type="primary" icon="el-icon-delete">批量删除</el-button>
            <el-button @click="() => openEditor()" v-show="!multiSelectionMode" type="primary" icon="el-icon-plus">新增课件</el-button>
            <el-button @click="multiSelectionMode = !multiSelectionMode" type="primary" :icon="!multiSelectionMode ? 'el-icon-delete' : ''" plain>{{ multiSelectionMode ? '取消批量删除' : '批量删除' }}
            </el-button>
        </div>
        <el-table :data="coursewareList" @selection-change="handleSelectionChange" v-loading="loading" border :class="[`table-fixed-col`, multiSelectionMode && `showSelection`]">
            <el-table-column v-if="multiSelectionMode" :width="getTableHeaderWidthByCheckCol()" class-name="selection" align="right" key="selection" type="selection"></el-table-column>
            <el-table-column label="序号" type="index" :index="indexFormatter" key="index" align="center" :width="getTableHeaderWidthByOrderCol()" fixed></el-table-column>
            <el-table-column label="课件名称" prop="name" key="name" fixed min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="课件类型" prop="coursewaretypename" key="coursewaretypename" align="center" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" prop="statusname" key="statusname" align="center" min-width="80" show-overflow-tooltip>
                <span slot-scope="{ row }" :style="{ color: parseStatusColor(row.status) }">{{ row.statusname }}</span>
            </el-table-column>
            <el-table-column label="创建时间" prop="datetime" key="datetime" align="center" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column v-if="!multiSelectionMode" label="操作" key="action" fixed="right" align="right" :width="getTableHeaderWidthByOpButton3()">
                <div class="flex ai-c jc-sb" slot-scope="{ row }">
                    <span @click="row.status !== 10 ? openEditor(row.code) : false" :class="row.status !== 10 ? 'color-primary pointer' : 'color-info'">编辑</span>
                    <span @click="row.status !== 10 ? releaseCourseware(row.code) : false" :class="row.status !== 10 ? 'color-primary pointer' : 'color-info'">发布</span>
                    <span @click="row.status !== 100 ? deleteCourseware(row.code) : false" :class="row.status !== 100 ? 'color-primary pointer' : 'color-info'">删除</span>
                </div>
            </el-table-column>
        </el-table>
        <el-pagination v-show="!multiSelectionMode" :hide-on-single-page="!total || total < 1" class="mt-20 flex ai-c jc-fd" @size-change="handePageSizeChange" @current-change="curPageChange" @prev-click="curPageChange" @next-click="curPageChange" layout="total, sizes, prev, pager, next" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="20" :current-page.sync="queryCache.page" background></el-pagination>
        <CoursewareEditor @complete="getCoursewareList" :visible.sync="editorVisible" :code="activeCode" />
    </div>
</template>
<script>
import {
  getCoursewareList,
  updateCoursewareStatus
} from '@/api/measApi/coursewareManage'
import { deepClone } from '@/common/js/tools'
import CoursewareEditor from './components/coursewareEditor.vue'
export default {
  components: {
    CoursewareEditor
  },
  data: () => ({
    activeCode: '',
    editorVisible: false, // 编辑弹窗可视性
    selectionCodes: [], // 多选code
    loading: false,
    multiSelectionMode: false, // 多选模式
    total: 0, // 查询数据量
    coursewareList: [], // 课件列表
    // 请求参数
    query: {
      condition: {
        name: ''
      }
    },
    // 请求参数缓存
    queryCache: {
      page: 1,
      pagesize: 20
    }
  }),
  created() {
    Object.assign(this.queryCache, deepClone(this.query))
    this.getCoursewareList()
  },
  methods: {
    // 充值搜索条件
    reset() {
      this.query.condition.name = ''
      this.getCoursewareList(this.query)
    },
    // 发布课件
    async releaseCourseware(code) {
      try {
        await this.$confirm('发布成功的课件可用于班级课程的设置，继续吗？', {
          customClass: 'measElMessage'
        })
        const res = await updateCoursewareStatus({ code, status: 10 })
        if (res.code === '000') {
          this.$message.success(res.msg)
          this.getCoursewareList()
        }
      } catch {}
    },
    // 打开编辑框
    openEditor(code = '') {
      this.activeCode = code
      this.editorVisible = true
    },
    // 删除课件（可批量）
    async deleteCourseware(codes) {
      if (codes instanceof Array) {
        if (!codes.length) {
          return this.$message.warning('请选择想要删除的数据')
        }
        codes = codes.join(',')
      }
      try {
        await this.$confirm(
          '课件删除后将不在前台展示，但不影响现有的排课信息，继续吗？',
          { customClass: 'measElMessage' }
        )
        this.loading = true
        const res = await updateCoursewareStatus({ code: codes, status: 100 })
        if (res.code === '000') {
          this.$message.success(res.msg)
          this.multiSelectionMode = false
          this.getCoursewareList()
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    },
    // 获取课件列表
    async getCoursewareList(param) {
      if (param) {
        this.queryCache.page = 1
      }
      Object.assign(this.queryCache, deepClone(param))
      this.loading = true
      try {
        const res = await getCoursewareList(this.queryCache)
        if (res.code === '000') {
          this.coursewareList = res.data
          this.total = res.pageinfo.rowcount
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    },
    // 处理多选
    handleSelectionChange(rows) {
      this.selectionCodes = rows.map(row => row.code)
    },
    // 解析状态颜色
    parseStatusColor(status) {
      switch (status) {
        case 0:
          return '#E6A23C'
        case 10:
          return '#67C23A'
        case 100:
          return '#F56C6C'
        default:
          return '#666'
      }
    },
    // 序号格式化
    indexFormatter(index) {
      return index + 1 + (this.queryCache.page - 1) * this.queryCache.pagesize
    },
    // 分页大小改变
    handePageSizeChange(e) {
      this.queryCache.page = 1
      this.queryCache.pagesize = e
      this.getCoursewareList()
    },
    // 页面跳转
    curPageChange(e) {
      this.queryCache.page = e
      this.getCoursewareList()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-button {
  height: 36px;
  min-width: 0;
}
.courseware-list {
  background-color: #fff;

  > .search-bar {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    > .el-input {
      margin-right: 10px;
      width: 50%;
      height: 36px;
      max-width: 400px;
    }

    > .btn-group {
      display: flex;
      align-items: center;
    }
  }

  > .toolbar {
    display: flex;
  }

  > .el-table {
    margin-top: 20px;
  }
}
</style>
